function updateButtons() {
  if($(".lease-application-selectors:checked").length === 0) {
    $("#createLeaseFromApplications").attr("disabled", "disabled");
    $("#archive_form button").attr("disabled", "disabled");
    $("#unarchive_form button").attr("disabled", "disabled");
  } else {
    $("#createLeaseFromApplications").removeAttr("disabled");
    $("#archive_form button").removeAttr("disabled");
    $("#unarchive_form button").removeAttr("disabled");
  }
}

module.exports = function() {
  $("#createLeaseFromApplications").click(function () {
    let values = $(".lease-application-selectors:checked").map(function() { return $(this).val(); }).toArray();
    Turbolinks.visit(`/leases/new?applications=${values}`)
  });

  $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    var target = $(e.target).attr("href") // activated tab
    if(target === '#new') {
      $("#archive_form").css('display', 'inline-block');
      $("#unarchive_form").hide();
    } else if (target === '#archived') {
      $("#archive_form").hide();
      $("#unarchive_form").css('display', 'inline-block');
    }
  });

  $("#archive_form").submit(function () {
    $(".lease-application-selectors:checked").map(function() { return $(this).val(); }).toArray()
        .forEach(function (val) {
          $("<input />").attr("type", "hidden")
                .attr("name", "ids[]")
                .attr("value", val)
                .appendTo("#archive_form");
        });
    return true;
  });

  $("#unarchive_form").submit(function () {
    $(".lease-application-selectors:checked").map(function() { return $(this).val(); }).toArray()
        .forEach(function (val) {
          $("<input />").attr("type", "hidden")
                .attr("name", "ids[]")
                .attr("value", val)
                .appendTo("#unarchive_form");
        });
    return true;
  });

  $(".lease-application-selectors").change(updateButtons);
  updateButtons();
}
